import React from "react";
import s from './Header.module.scss'
import {GlobalSvgSelector} from "../../../assets/images/icons/global/GlobalSvgSelector";
import {useTheme} from "../../../hooks/useTheme";
import {Theme} from "../../../context/ThemeContext";
import {HeaderSearch, HeaderSearchProps} from "./HeaderSearch";




export const Header = ({ onSearchChange }: HeaderSearchProps) => {
    const theme = useTheme();

    function changeTheme() {
        theme.changeTheme(theme.theme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT);
    }


    return (
        <header className={s.header}>
            <div className={s.wrapper}>
                <div className={s.logo}>
                    <GlobalSvgSelector id="header-logo" />
                </div>
                <div className={s.title}>React weather</div>
            </div>
            <div className={s.wrapper}>
                <div className={s.change_theme} onClick={changeTheme}>
                    <GlobalSvgSelector id="change-theme" />
                </div>
                <HeaderSearch onSearchChange={onSearchChange}/>
            </div>

        </header>
    );
};